import React from 'react';

const Footer = () =>
	<footer>
		<ul className='contact'>
			<li className='address'>
				наша адреса
				<div className='line'></div>
				<div className='txt'>
					Канiв<br/>
					Черкаськая обл<br/>
					вул. Iльэнка 33/а
				</div>
			</li>
			<li className='soc'>
				<ul>
					<li><a href=''>
						<img src={require('../../img/footer/telegram.png')} alt=''/>
					</a></li>
					<li><a href=''>
						<img src={require('../../img/footer/facebook.png')} alt=''/>
					</a></li>
					<li><a href=''>
						<img src={require('../../img/footer/instagramm.png')} alt=''/>
					</a></li>
				</ul>
			</li>
			<li className='tel'>
				нашi телефони
				<div className='line'></div>
				<div className='txt'>
					+38(093)981-84-47<br/>
					+38(068)723-24-11
				</div>
			</li>
		</ul>
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d554886.425432003!2d31.141649767097405!3d49.757264460688575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d40c75f1ebb33d%3A0x9b9f7a7b0b4859a8!2sKaniv%2C+Cherkasy+Oblast%2C+19000!5e0!3m2!1sen!2sua!4v1539466978930" allowFullScreen></iframe>
		<a className='we' href='https://www.facebook.com/bringmetheaugust' target="_blank" className='we'>
			made by BringMeTheAugust
		</a>
	</footer>

export default Footer;